<template>
  <div class="changename">
    <z-fix-top
      keep-position
      class="fixtop"
    >
      <z-nav-bar
          class="navbar"
          left-arrow
          title="更新姓名"
          @click-left="closePage"
      >
      </z-nav-bar>
    </z-fix-top>
    <z-notice-bar
        v-show="!success"
        left-icon="volume-o"
        :scrollable="false"
        text="仅支持本人信息修改，不支持变更为他人。"
      />
    <section v-show="!success" class="content">
      <div class="currentname">
        当前真实姓名：{{ curname }}
      </div>
      <z-field v-model="newname" placeholder="请输入修改后姓名" />
      <z-divider />
      <section v-show="needCard" class="upload-area">
        <media-upload-item tip="" type="front" @uploaded="frontPicUploaded">
        </media-upload-item>
        <media-upload-item tip="" type="back" @uploaded="backPicUploaded">
        </media-upload-item>
      </section>
      <z-checkbox-group v-model="radio">
        <z-checkbox v-if="isZZ" name="zz">
          我已阅读并同意
          <span :style="{ color: '#42A0FF' }" @click.stop="zzagreement">《实人认证服务协议》</span>
        </z-checkbox>

        <z-checkbox v-if="isSJJ" name="sjj">
          我已阅读并同意
          <span :style="{ color: '#42A0FF' }" @click.stop="sjjagreement">《实人认证服务协议》</span>
        </z-checkbox>

        <z-checkbox name="privacy">
          我已阅读并同意
          <span :style="{ color: '#42A0FF' }" @click.stop="checkInfo">《个人信息处理授权书》</span>
        </z-checkbox>

        <z-checkbox v-if="isZLJ" name="zlj">
          我已阅读并同意
          <span :style="{ color: '#42A0FF' }" @click.stop="zljagreement">《找靓机身份识别服务协议》</span>
        </z-checkbox>
      </z-checkbox-group>
      <z-button-group>
        <z-button type="primary" :loading="loading" :disabled="!canSubmit" @click="submit">提交</z-button>
      </z-button-group>
    </section>

    <section v-show="success" class="success">
      <!-- generated by ai -->
      <img :src="$setPicSize(successImg)" alt="">
      <header>恭喜您认证成功</header>
      <z-button type="primary" @click="closePage">返回</z-button>
    </section>
  </div>
</template>

<script>
import { NavBar, Button, ButtonGroup, FixTop, NoticeBar, Field, Checkbox, CheckboxGroup, Divider } from '@zz-common/zz-ui';
import { apiRealAuthGetRenameInfo, apiRealAuthSubmitRenameInfo } from '@api/resourceApi'
import { queryParams, getCookie } from '../../lib/utils'
import native from '@zz-common/native-adapter'
import { lego } from '@zz-common/lego'
// generated by ai
import { setPicSize } from '@zz-common/zz-utils'
import MediaUploadItem from './MediaUploadItem/MediaUploadItem'

const query = queryParams()
export default {
  name: 'ChangeName',
  components: {
    'z-nav-bar': NavBar,
    'z-fix-top': FixTop,
    'z-button': Button,
    'z-divider': Divider,
    'z-checkbox-group': CheckboxGroup,
    'z-checkbox': Checkbox,
    'z-button-group': ButtonGroup,
    'z-notice-bar': NoticeBar,
    'z-field': Field,
    MediaUploadItem
  },
  data() {
    // 获取Cookie中的t值判断是否为奢竞界APP
    const tValue = getCookie('t')
    const isSJJ = tValue === '243' || tValue === '244'

    return {
      radio: [],
      newname: '',
      curname: '',
      picFront: '',
      picBack: '',
      needCard: false,
      sourceCode: query.sourceCode || this.$route.query.sourceCode || '',
      success: false,
      successImg: require('./images/auth_success.png'),
      isZZ: native.in('zz'),
      isZLJ: native.in('zlj'),
      isSJJ,
      loading: false
    }
  },
  computed: {
    canSubmit() {
      // 个人信息处理授权书是必选的
      const hasPrivacy = this.radio.includes('privacy')
      // 转转实人认证服务协议（如果显示）
      const hasZZ = !this.isZZ || this.radio.includes('zz')
      // 找靓机身份识别服务协议（如果显示）
      const hasZLJ = !this.isZLJ || this.radio.includes('zlj')
      // 奢竞界实人认证服务协议（如果显示）
      const hasSJJ = !this.isSJJ || this.radio.includes('sjj')

      const allAgreed = hasPrivacy && hasZZ && hasZLJ && hasSJJ

      if (this.needCard) {
        return this.newname && this.picBack && this.picFront && allAgreed
      } else {
        return !!this.newname && allAgreed
      }
    }
  },
  methods: {
    // generated by ai
    $setPicSize(url) {
      return setPicSize(url)
    },
    zzagreement() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/67e371c0da1f4e0062fc0d97/index.html?magicplatform=zz&needNewWebview=1',
        needClose: '0'
      })
    },
    zljagreement() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/6401c5d7c955420077193c75/index.html?magicplatform=zlj&needNewWebview=1',
        needClose: '0'
      })
    },
    sjjagreement() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/691c3375ee471600647e64f8/index.html?magicplatform=zz&needNewWebview=1',
        needClose: '0'
      })
    },
    checkInfo() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/6401a9e6447e27006914ecb0/index.html?magicplatform=common&needNewWebview=1',
        needClose: '0'
      })
    },
    closePage() {
      native.close()
    },
    frontPicUploaded(rst) {
      lego.send({
        pagetype: 'auth_changename',
        actiontype: 'front_pic',
        backup: {
          sourcecode: this.sourceCode,
          version: getCookie('v'),
          app: native.in('zz') ? 'zz' : 'zlj'
        }
      })
      this.picFront = rst
    },
    backPicUploaded(rst) {
      lego.send({
        pagetype: 'auth_changename',
        actiontype: 'back_pic',
        backup: {
          sourcecode: this.sourceCode,
          version: getCookie('v'),
          app: native.in('zz') ? 'zz' : 'zlj'
        }
      })
      this.picBack = rst
    },
    submit() {
      this.loading = true
      lego.send({
        pagetype: 'auth_changename',
        actiontype: 'submit',
        backup: {
          sourcecode: this.sourceCode,
          version: getCookie('v'),
          app: native.in('zz') ? 'zz' : 'zlj'
        }
      })
      apiRealAuthSubmitRenameInfo({
        newName: this.newname,
        sourceCode: this.sourceCode,
        picFront: this.picFront,
        picBack: this.picBack
      }).then(_res => {
        lego.send({
          pagetype: 'auth_changename',
          actiontype: 'success',
          backup: {
            sourcecode: this.sourceCode,
            version: getCookie('v'),
            app: native.in('zz') ? 'zz' : 'zlj'
          }
        })
        this.success = true
        this.loading = false
      }).catch(err => {
        console.log(err)
        lego.send({
          pagetype: 'auth_changename',
          actiontype: 'fail',
          backup: {
            sourcecode: this.sourceCode,
            version: getCookie('v'),
            app: native.in('zz') ? 'zz' : 'zlj'
          }
        })
        this.loading = false
      })
    }
  },
  watch: {
    newname: function(newval, _oldval) {
      this.newname = newval.replace(/\./g, '·')
    }
  },
  created() {
    apiRealAuthGetRenameInfo({ sourcecode: this.sourceCode }).then(res => {
      this.needCard = res.needCard
      this.curname = res.name
      if (this.needCard) {
        lego.send({
          pagetype: 'auth_changename',
          actiontype: 'pic_show',
          backup: {
            sourcecode: this.sourceCode,
            version: getCookie('v'),
            app: native.in('zz') ? 'zz' : 'zlj'
          }
        })
      }
    })
    native.wrap('setHeaderVisible')({
      visible: '0'
    })
  },
  mounted() {
    lego.send({
      pagetype: 'auth_changename',
      actiontype: 'show',
      backup: {
        sourcecode: this.sourceCode,
        version: getCookie('v'),
        app: native.in('zz') ? 'zz' : 'zlj'
      }
    })
  }
}
</script>

<style lang="less" scoped>
@import "index.less";
</style>